export const THIRTY_MINUTES = 30 * 60 * 1000
export const LOCK_KEY = "auth_refresh_lock"
export const LOCK_TTL = 30_000 // 30s

export const parseJwt = (token: string) => {
	if (!token || token.split(".").length !== 3) {
		throw new Error("Invalid token format")
	}

	const base64Url = token.split(".")[1]
	const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/")

	try {
		const jsonPayload = atob(base64)
		return JSON.parse(jsonPayload)
	} catch {
		throw new Error("Failed to decode token")
	}
}

export const isExpired = (token: string): boolean => {
	try {
		const payload = parseJwt(token)
		return payload.exp * 1000 < Date.now()
	} catch {
		return true
	}
}

export const willExpireSoon = (exp: number): boolean => {
	const expiresAt = exp * 1000
	return expiresAt - Date.now() <= THIRTY_MINUTES
}

export const hasLock = (): boolean => {
	const lock = localStorage.getItem(LOCK_KEY)
	return lock !== null && Date.now() - Number(lock) < LOCK_TTL
}

export const acquireLock = () => {
	localStorage.setItem(LOCK_KEY, Date.now().toString())
}

export const releaseLock = () => {
	localStorage.removeItem(LOCK_KEY)
}

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))
